import { render, staticRenderFns } from "./ResTemplateModify.vue?vue&type=template&id=f25aca24"
import script from "./ResTemplateModify.vue?vue&type=script&lang=js"
export * from "./ResTemplateModify.vue?vue&type=script&lang=js"
import style0 from "./ResTemplateModify.vue?vue&type=style&index=0&id=f25aca24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports